<!-- <div class="p-col-12">
<p-steps [model]="dataSubmitSteps" [activeIndex]="activeIndex"></p-steps>
</div> -->
<p-card>
  <ng-template pTemplate="title"> Validation Results </ng-template>
  <ng-template pTemplate="subtitle">
    Review potential issues with your data
  </ng-template>
  <ng-template pTemplate="content">
    <div class="flex flex-column p-2">
      <div class="p-card-title">
        Validation status of mzTab-M files in submission
      </div>
      <div style="overflow-x: auto; min-width: 0;">
      <p-table
        [value]="mzTabFiles"
        id="mzTabResultSubmissions"
        responsiveLayout="stack"
        [paginator]="true"
        [rows]="10"
        [loading]="progress"
        class="w-full"
        >
        <ng-template pTemplate="header">
          <tr>
            <th>File Name</th>
            <!-- <th>File Type</th>
            <th>License</th>
            <th>SHA-256 Hash</th> -->
            <th>Status</th>
            <th>Validation Messages</th>
            <th>Actions</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-mzTabFile>
          <tr>
            <!-- <td class="align-middle"><p-button label="{{ mzTabFile.fileName }}" [link]="true" (onClick)="edit(mzTabFile)"/></td> -->
            <td class="align-middle"><span class="p-column-title">File Name</span>{{ mzTabFile.fileName }}</td>
            <td class="align-middle"><span class="p-column-title">Status</span>
              <!-- display the overall validation status, e.g. "unknown" as a grey question mark if checkWasValidated returns false for the file, a green double check mark if isValid() is true, a red times otherwise -->
              <div
                class="bg-surface-0 dark:bg-surface-900 flex items-center gap-2 justify-center py-1 px-2"
                >
                <!-- <span *ngIf="!checkWasValidated(mzTabFile)" class="text-xl font-semibold text-gray-500">
                <i class="fas fa-question"></i>
                <span class="text-sm font-semibold text-gray-500">
                  Unknown
                </span>
              </span> -->
              @if (isValid(mzTabFile)) {
                <span
                  class="text-xl font-semibold text-green-500"
                  >
                  <i class="fas fa-check-double"></i>
                  <span class="text-sm font-semibold text-green-500">
                    Valid
                  </span>
                </span>
              }
              @if (!isValid(mzTabFile)) {
                <span
                  class="text-xl font-semibold text-red-500"
                  >
                  <i class="fas fa-times"></i>
                  @if (!checkWasValidated(mzTabFile)) {
                    <span
                      class="text-sm font-semibold text-red-500"
                      >
                      Not validated
                    </span>
                  }
                </span>
              }
            </div>
          </td>
          <td class="align-middle"><span class="p-column-title">Validation Messages</span>
            <div>
              <!-- check that length of validation messages for this fileName is 0 -->
              @if (
                hasValidationMessages(mzTabFile)) {
                <div
                  >
                  <div style="overflow: auto; max-height: 400px;">
                  <p-table
                    [value]="this.validationMessages[mzTabFile.fileName]"
                    class="p-datatable-gridlines p-datatable-striped"
                    responsiveLayout="stack"
                    >
                    <ng-template pTemplate="header">
                      <tr>
                        <th>Level</th>
                        <th>Source</th>
                        <th>Category</th>
                        <th>Code</th>
                        <th>Message</th>
                      </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-validationMessage>
                      <tr>
                        <td>
                          <span class="p-column-title">Level</span>
                          <!-- replace with colored font icon -->
                          @if (validationMessage.level === 'ERROR') {
                            <span
                              class="text-xl font-semibold text-red-500"
                              >
                              <i class="fas fa-times" aria-label="ERROR"></i>
                            </span>
                          }
                          @if (validationMessage.level === 'WARN') {
                            <span
                              class="text-xl font-semibold text-yellow-500"
                              >
                              <i
                                class="fas fa-exclamation-triangle"
                                aria-label="WARN"
                              ></i>
                            </span>
                          }
                          @if (validationMessage.level === 'INFO') {
                            <span
                              class="text-xl font-semibold text-blue-500"
                              >
                              <i class="fas fa-info" aria-label="INFO"></i>
                            </span>
                          }
                        </td>
                        <td><span class="p-column-title">Source</span>{{ validationMessage.source }}</td>
                        <td><span class="p-column-title">Category</span>{{ validationMessage.category }}</td>
                        <td><span class="p-column-title">Code</span>{{ validationMessage.code }}</td>
                        <td><span class="p-column-title">Message</span>{{ validationMessage.message }}</td>
                      </tr>
                    </ng-template>
                  </p-table>
                  </div>
                </div>
              } @else {
                @if (
                  checkWasValidated(mzTabFile) &&
                  !hasValidationMessages(mzTabFile)
                  ) {
                  <span
                    class="text-xl font-semibold text-green-500"
                    >
                    <i class="fas fa-check"></i>
                    <span class="text-sm font-semibold text-green-500">
                      No validation messages
                    </span>
                  </span>
                }
                @if (!checkWasValidated(mzTabFile)) {
                  <span
                    class="text-xl font-semibold text-red-500"
                    >
                    <i class="fas fa-times"></i>
                    <span class="text-sm font-semibold text-red-500">
                      File was not validated yet. Please run the validation!
                    </span>
                  </span>
                }
              }
            </div>
          </td>
          <td class="align-top">
            <div
              class="file-list-action pl-2"
              >
              <button
                pButton
                type="button"
                class="flex p-button-default"
                icon="fas fa-check-double"
                label="Validate"
                (click)="validate(mzTabFile)"
              ></button>
            </div>
          </td>
        </tr>
      </ng-template>
    </p-table>
    </div>
    <div class="p-2">
      @if (!allFilesValid() && !progress) {
        <small class="p-error block"
          >Please validate all files!</small
          >
        }
      </div>
    </div>
  </ng-template>
  <ng-template pTemplate="footer">
    @if (submission) {
      <div
        class="flex justify-content-between flex-wrap flex-row"
        >
        <p-buttongroup>
          <button
            pButton
            type="button"
            label="Back"
            (click)="previousPage($event)"
            icon="fa fa-chevron-left"
            iconPos="left"
          ></button>
          <button
            pButton
            type="button"
            label="Cancel"
            (click)="cancel($event)"
            icon="fa fa-times"
            iconPos="right"
            class="p-button-danger"
          ></button>
        </p-buttongroup>
        <button
          pButton
          type="button"
          label="Next"
          (click)="nextPage($event)"
          icon="fa fa-chevron-right"
          iconPos="right"
          [disabled]="!allFilesValid()"
        ></button>
      </div>
    }
  </ng-template>
</p-card>
